import {
    ResultObj,
    allFetch
} from "../Domain";

/**
 * 列印內容
 * @param {string} qrcode  QRCode內容
 * @param {string} vin_no  車身碼
 * @param {string} qrcode_type  QRCode種類
 * @param {string} note  備註
 * @param {number} count  張數
 */
export interface PrintType_CarStockQRCode {
    qrcode: string;
    vin_no: string;
    qrcode_type: string;
    note: string;
    count: number;
}

/**
 * @description 呼叫標籤機列印API
 * @param {string} connect_type 連線方式(USB或IP)
 * @param {string} position_id 據點流水號
 * @param {string} print_type 列印種類
 * @param {PrintType_CarStockQRCode[]} contents 內容們
 */
export interface Printer_LabelMachineParams {
    connect_type: string;
    position_id?: string;
    print_type: string;
    contents: PrintType_CarStockQRCode[]
}
export const Printer_LabelMachine = async (params: Printer_LabelMachineParams): Promise<ResultObj> =>
    await allFetch('Printer/Printer_LabelMachine', params);
